import styled, { css } from 'styled-components';
import Icon from '../../_shared/components/Icon';
import Toggle from '../../_shared/components/Toggle';
import Button from '../../_shared/components/Button';
import Label from '../../_shared/components/Label';
import Box from '../../_shared/components/Box';
import isOmpPlatform from '../../_shared/utils/isOmpPlatform';

const isOmp = isOmpPlatform();

const containerVariants = {
  '': css``,
  omp: css`
    background: ${({ theme }) => theme.COLORS.TRANSPARENT};
  `
};
export const RetailContainer = styled.div`
  @media only screen and (min-width: ${({ theme }) =>
      theme.BP.CUSTOM_DESKTOP_SMALL}) {
    padding: 106px;
  }
  ${props => containerVariants[props.variant]};
`;

export const Main = styled.div`
  max-width: 900px;
  background: ${({ theme }) => theme.COLORS.BASE};
  border-radius: 3px;
  margin: 0 auto;
  padding: ${({ isStandardUser }) =>
    isStandardUser ? '0px' : '30px 10px 10px 0px'};

  @media only screen and (max-width: ${({ theme }) =>
      theme.BP.RETAIL_CUSTOM_MOBILE_SMALL}) {
    max-width: 100%;
  }
`;

export const Header = styled.header`
  position: relative;
`;

export const Title = styled.h1`
  font-size: ${({ theme }) => theme.FONT_SIZES.XXLARGE};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  margin: 6px 0 26px 0;
`;

export const SubHeading = styled.p`
  margin: 25px 0;
`;

export const Form = styled.form``;

export const FormTitle = styled.h2`
  font-size: ${({ theme }) => theme.FONT_SIZES.MEDIUM};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  && {
    margin-bottom: 24px;
  }
`;

export const FormLabel = styled.label`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
`;

export const SelectAllButton = styled(Button.Transparent)`
  text-transform: initial;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  color: ${({ theme }) => theme.COLORS.TERTIARY};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  letter-spacing: normal;
  padding: 0;
`;

export const PriceContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 6px 0;
  height: max-content;

  input {
    border-left: none;
    border-radius: 0 3px 3px 0;
  }
`;

export const PriceInput = styled.span`
  display: block;
  height: 100%;
  width: max-content;
  border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_20};
  border-radius: 3px 0 0 3px;
  border-right: none;
  background: white;
  padding: 10px 0 10px 12px;
`;

export const PriceDisclaimer = styled.p`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  margin-bottom: 24px;
`;

export const Section = styled.section`
  border-top: 2px solid
    ${({ theme }) =>
      isOmp ? theme.COLORS.NEUTRAL_110 : theme.COLORS.NEUTRAL_50};
  padding: 18px 0;
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;
`;

export const VehiclePhotosContainer = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: 18px 0;

  @media only screen and (max-width: ${({ theme }) =>
      theme.BP.RETAIL_CUSTOM_MOBILE_SMALL}) {
    margin: 20px -28px;
  }
`;

export const StyledToggle = styled(Toggle)`
  margin-right: 14px;
`;

export const ToggleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const DealershipContainer = styled.ul`
  @media only screen and (min-width: ${({ theme }) =>
      theme.BP.VDP_DESKTOP_WL}) {
    display: grid;
    grid-template-columns: 216px 360px 216px;
    grid-gap: 21px 18px;
  }

  input {
    margin-top: 6px;
  }

  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    li {
      margin-bottom: 12px;
    }
  }
`;

export const Footer = styled.footer`
  border-top: 2px solid
    ${({ theme }) =>
      isOmp ? theme.COLORS.NEUTRAL_110 : theme.COLORS.NEUTRAL_50};
  padding-top: 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    flex-direction: column;
  }
`;

export const FooterText = styled.p`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  margin-top: 24px;
`;

export const CreatePageDescription = styled.p`
  margin: 0 84px 0 0;
  line-height: 22px;

  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    width: 100%;
    margin: 0 0 12px 0;
  }
`;

export const StyledCreatePageButton = styled(Button.Primary)`
  min-width: 207px;
  max-height: 48px;
  font-size: ${({ theme }) => theme.FONT_SIZES.MEDIUM};
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px 16px 30px;
  svg {
    width: 16px;
    height: 16px;
  }
  text-transform: ${isOmp ? 'none' : 'uppercase'};
`;
const closeVariants = {
  '': css`
    width: 88px;
    height: 30px;
    top: 36px;
    right: 36px;
    border: 2px solid ${({ theme }) => theme.COLORS.BASE_INVERTED};
    border-radius: 4px;

    &:hover {
      background-color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
      color: ${({ theme }) => theme.COLORS.BASE};
      path {
        stroke: ${({ theme }) => theme.COLORS.BASE};
        stroke-width: 4px;
      }
    }

    @media only screen and (max-width: ${({ theme }) =>
        theme.BP.VDP_MOBILE_WH}) {
      display: none;
    }
  `,
  omp: css`
    width: 30px;
    height: 30px;
    top: 0px;
    right: 0px;
    border: none;
  `
};

export const CloseButton = styled.button`
  ${props => closeVariants[props?.variant || '']};
  position: absolute;
  background-color: ${({ theme }) => theme.COLORS.BASE};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};

  letter-spacing: ${({ theme }) => theme.LETTER_SPACING.WIDE};
  margin-left: 9px;
  padding: 0;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

CloseButton.Icon = styled(Icon).attrs({
  icon: 'TR5-Close_X'
})`
  width: 10px;
  height: 10px;
  margin-left: 4px;
  path {
    stroke: ${({ theme }) => theme.COLORS.BASE_INVERTED};
    stroke-width: 2px;
  }
`;

export const StyledImageLabel = styled(Label.Small)`
  min-height: 14px;
  height: max-content;
  margin-left: 6px;
`;

export const StyledImageAndLabelContainer = styled(Box.Column)`
  max-width: calc(20% - 20px);
  margin-right: 24px;
  margin-bottom: 16px;

  &:nth-child(5n) {
    margin-right: 0;
  }

  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    max-width: calc(25% - 18px);

    &:nth-child(5n) {
      margin-right: 24px;
    }

    &:nth-child(4n) {
      margin-right: 0;
    }
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.BP.RETAIL_CUSTOM_MOBILE_LARGE}) {
    max-width: calc((100% / 3) - 18px);

    &:nth-child(4n) {
      margin-right: 24px;
    }

    &:nth-child(3n) {
      margin-right: 0;
    }
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.BP.RETAIL_CUSTOM_MOBILE_SMALL}) {
    max-width: calc(50% - 2px);
    width: 100%;

    &:nth-child(2n-1) {
      margin-right: 1px;
    }

    &:nth-child(2n) {
      margin-right: 0;
    }
  }
`;

export const MainContainer = styled.div`
  max-width: 900px;
  padding: 0 30px 30px 30px;
  background: ${({ theme }) => theme.COLORS.BASE};
  border-radius: 3px;
  margin: 0 auto;

  @media only screen and(max-width: ${({ theme }) =>
    theme.BP.RETAIL_CUSTOM_MOBILE_SMALL}) {
    max-width: 100%;
  }
`;

export const LearnMoreContainer = styled.div`
  background: ${({ theme }) => theme.COLORS.LIMEADE};
  border: 2px solid ${({ theme }) => theme.COLORS.BRAND};
  height: 30px;
  padding: 15px 10px 35px 10px;

  @media only screen and (max-width: 621px) {
    padding-bottom: 55px;
  }
`;

export const StyledUpgradeIcon = styled(Icon).attrs({
  icon: 'TR5-UpgradeSubscriptionIcon'
})`
  width: 20px;
  height: 20px;
  margin-left: 4px;
  display: inline;
`;

export const LearnMoreText = styled.div`
  position: absolute;
  display: inline;
  margin-left: 7px;
`;

export const LearnMoreLink = styled.a`
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  text-decoration: underline;
  cursor: pointer;
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};

  &:visited {
    color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  }
`;
